"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBookmarkOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6 2h12c1.333 0 2 .667 2 2v16.532c0 .588-.222 1.01-.665 1.265-.443.256-.888.274-1.335.056l-6-2-6 2c-.48.216-.932.198-1.36-.056-.426-.253-.64-.675-.64-1.265V4c0-1.333.667-2 2-2zm0 2v15.846l6-1.992 6 1.992V4H6z' }))); };
exports.default = SvgBookmarkOutline;
//# sourceMappingURL=BookmarkOutline.js.map